<template>
    <div class="columns is-centered is-multiline has-text-centered">
        <div class="column is-12 has-text-right">
            <div class="field mr-3">
                <div class="control">
                    <label class="mr-2"
                        >Recarga en {{ reloadCountdown }} segundos</label
                    >
                    <button
                        class="button is-primary"
                        @click="reload"
                        :disabled="isLoading"
                    >
                        <Icon family="fal" name="fa-sync" />
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-10">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2">
                Ciudadanos
            </h5>
            <div class="columns is-centered">
                <div class="column is-2 banner">
                    <p class="number">{{ kpi.waiting }}</p>
                    <p class="text">En espera</p>
                </div>
                <div class="column is-2 banner">
                    <p class="number">{{ kpi.onRoom }}</p>
                    <p class="text">En sala</p>
                </div>
                <div class="column is-2 banner">
                    <p class="number">{{ kpi.served }}</p>
                    <p class="text">Atendidos</p>
                </div>
            </div>
        </div>
        <div class="column is-10">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2">
                Trámites de ciudadanos en espera
            </h5>
            <Skills :skills="filteredSkill" />
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import Skills from "./Skills.vue";

export default {
    name: "users-kpi",
    components: {
        Skills,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        this.retrieveData();
        this.signalRSocket.on("OperatorJoined", this.operatorJoined);
        this.signalRSocket.on("OperatorLeaved", this.operatorLeaved);
    },
    beforeDestroy() {
        this.stopTimer();
    },
    data() {
        return {
            isLoading: true,
            kpi: {},

            reloadCountdown: 60,
            reloadTimer: null,
        };
    },
    computed: {
        skills() {
            return this.kpi.groupedSkills;
        },
        filteredSkill() {
            let skills = this.skills;
            return skills?.sort((a, b) => b.count - a.count);
        },
    },
    methods: {
        startTimer() {
            this.reloadTimer = setInterval(() => {
                this.reloadCountdown--;
                if (!this.isLoading && this.reloadCountdown === 0) {
                    this.reloadCountdown = 60;
                    this.retrieveData();
                } else if (this.reloadCountdown <= 0) {
                    this.reloadCountdown = 60;
                }
            }, 1000);
        },
        stopTimer() {
            this.reloadCountdown = 60;
            clearInterval(this.reloadTimer);
        },
        operatorJoined() {
            this.retrieveData();
        },
        operatorLeaved() {
            this.retrieveData();
        },
        reload() {
            this.retrieveData();
        },
        async retrieveData() {
            this.stopTimer();
            this.isLoading = true;

            let response = await RepositoryFactory.conference.kpi();
            this.kpi = response.data;

            this.isLoading = false;
            this.startTimer();
        },
    },
};
</script>

<style lang="scss" scoped>
.banner {
    margin: 1rem 2rem;

    .number {
        font-size: 3rem;
        font-weight: bold;
        margin-right: 0rem;
    }

    .text {
        font-size: 1.25rem;
    }
}
</style>